import { render, staticRenderFns } from "./LoginFormBiz.vue?vue&type=template&id=6f72b1e6&scoped=true&"
import script from "./LoginFormBiz.vue?vue&type=script&lang=js&"
export * from "./LoginFormBiz.vue?vue&type=script&lang=js&"
import style0 from "./LoginFormBiz.vue?vue&type=style&index=0&id=6f72b1e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72b1e6",
  null
  
)

export default component.exports